import React from 'react';

const SwitchTimer = ({ timeRemaining }) => {
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div className="fixed bottom-8 right-8 bg-gray-800 rounded-lg p-4 border border-gray-700">
      <div className="text-sm text-gray-400 mb-1 text-center">Switches in</div>
      <div className="text-4xl font-bold text-center">{formatTime(timeRemaining)}</div>
    </div>
  );
};

export default SwitchTimer;